<template>
  <div :class="['media-container', { 'no-text': isEmptyText, 'static-view': staticView }]">
    <div class="selected-media-item">
      <PostMediaItem :media="postMedia[0]" :controls="!staticView" @click="handleClick(0)" />
    </div>
    <template v-if="postMedia.length > 1">
      <PostMediaItem
        v-for="(media, index) in filteredPostMedia"
        :key="index"
        class="media-list-item"
        :media="media"
        :controls="false"
        muted
        :show-more="isShowMoreTile(index)"
        @click="handleClick(index + 1)"
      />
    </template>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import type { Post } from '../../types';
import PostHelper from '../helpers/post.helper';
import type { PostMedia } from '../../types/post';
import { PostMediaType } from '../../types/enums/post-media-type';
import PostMediaItem from './PostMediaItem.vue';

export default defineComponent({
  components: {
    PostMediaItem,
  },
  props: {
    post: {
      type: Object as PropType<Post>,
      required: true,
    },
    postMedia: {
      type: Array as PropType<PostMedia[]>,
      default: () => [],
    },
    staticView: {
      type: Boolean,
    },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const isEmptyText = computed(() => PostHelper.isEmptyText(props.post.text));
    const filteredPostMedia = computed(() => props.postMedia.slice(1, 4));
    const showMoreCount = computed(() => props.postMedia.length - 3);
    const isShowMoreTile = (index: number) =>
      (index === 2 && props.postMedia.length > 4 && showMoreCount.value) || 0;

    const handleClick = (index: number) => {
      if (props.staticView || (index === 0 && props.postMedia[0].type === PostMediaType.Video)) {
        return;
      }
      emit('click', index);
    };

    return {
      isEmptyText,
      filteredPostMedia,
      showMoreCount,
      PostMediaType,
      isShowMoreTile,
      handleClick,
    };
  },
});
</script>
<style lang="scss" scoped>
$grid-gap: calc(var(--spacing-150) / 4);

.media-container {
  display: grid;
  gap: var(--spacing-50);
  grid-template-columns: repeat(3, calc(33.33% - #{$grid-gap}));
  margin: var(--spacing-150) 0 0;

  &:hover:not(.static-view) {
    cursor: pointer;
  }

  .selected-media-item {
    grid-column: 1 / span 3;
    overflow: hidden;
    position: relative;
    margin-bottom: var(--spacing-50);

    .media-item {
      max-height: unset;
    }
  }

  .carousel-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;

    &.prev {
      left: var(--spacing-50);
    }

    &.next {
      right: var(--spacing-50);
    }
  }

  .media-list-item {
    :deep(.video-player-container button) {
      pointer-events: none;
    }
  }
}
</style>
